var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&cacheDirectory=true&sourceMap=true!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RoSignUpBox.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-cfb089ce\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RoSignUpBox.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/ro-sign-up/RoSignUpBox.vue
// module id = 337
// module chunks = 1